import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {BarCodeScannerContext} from "../../../../../../../contexts/barCodeScannerContext";
import {Grid} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import MobileItem from "../../../../../../../components/WMS/Mobile/MobileItem";
import {FormattedMessage} from "react-intl";
import RightDrawer from "../../../../../../../components/WMS/Mobile/RightDrawer";
import {blueColor} from "../../../../../../../assets/jss/main";
import Badge from "../../../../../../../components/Badge";
import {ShippingMethodsDiscr} from "../../../../../../../utils/ShippingMethods";
import ArrowDownIcon from "../../../../../../../components/icons/ArrowDownIcon";
import CustomButton from "../../../../../../../components/CustomButton";
import ShipmentModal from "./component/ShipmentModal";
import TipperManualSelectionDrawer from "./component/TipperManualSelectionDrawer";
import {getWMSContainerWithCodeBar} from "../../../../../../../api/wms/wmsContainers/wmsContainers";
import {assignShipmentToContainer} from "../../../../../../../api/wms/shipment/shipment";
import {shipmentSorted} from "../../../../../../../api/wms/shipment/shipment";
import {WmsContainerType} from "../../../../../../../utils/WMSContainerType";
import Toast from "../../../../../../../components/WMS/Toast";
import ErrorIcon from "../../../../../../../assets/img/error.svg";
import {KNCarrierType} from "../../../../../../../utils/KuehneNagelCarrierType";
import {WMSContext} from "../../../../../context/WMSContext";
import FullTransfer from "../../../../../../../components/WMS/MassTransfert/FullTransfer";
import WMSCarrierIcon from "../../../../../../../components/WMS/WMSCarrierIcon";
import ContainerCheckbox from "views/wms/shipping/components/ShippingMethodDrawer/components/ContainerAccordion/ContainerCheckbox";
import AccordionShipmentItem from "views/wms/shipping/components/ShippingMethodDrawer/components/ContainerAccordion/AccordionShipmentItem";

ContainerDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    inSorting: PropTypes.bool.isRequired,
    setInSorting: PropTypes.func.isRequired,
    container: PropTypes.object.isRequired,
    resetList: PropTypes.bool.isRequired,
    setResetList: PropTypes.func.isRequired,
    scannedShipment: PropTypes.object
};

function ContainerDrawer({
                             open,
                             handleClose,
                             inSorting,
                             setInSorting,
                             container,
                             beginSorting,
                             resetList,
                             setResetList,
                             scannedShipment = null
                         }) {
    const {scannedString, resetScannedString, setEnableScan} = useContext(BarCodeScannerContext)
    const {currentInventory, currentOrganization, isMobile} = useContext(WMSContext)

    const [openShipmentModal, setOpenShipmentModal] = useState(false)
    const [currentShipment, setCurrentShipment] = useState()
    const [openTipperManualSelectionDrawer, setOpenTipperManualSelectionDrawer] = useState(false)
    const [isCC, setIsCC] = useState(false)
    const [ccError, setCcError] = useState(false)
    const [isCcInternalWMSShip, setIsCcInternalWMSShip] = useState(false)
    const [massTransfer, setMassTransfer] = useState(false)
    const [openWrongContainerScanToast, setOpenWrongContainerScanToast] = useState(false)
    const [loading, setLoading] = useState(false)
    const [selectedShipmentByGroup, setSelectedShipmentByGroup] = useState({})

    const iconSize = '16px';

    function isShipmentSelected(shipmentId, groupId) {
        return selectedShipmentByGroup?.[groupId]?.some(s => s.shipmentId === shipmentId) || false
    }

    function groupHasSelectedShipments(groupId) {
        return selectedShipmentByGroup?.[groupId]?.length > 0
    }

    function selectShipment(shipment, groupId) {
        setSelectedShipmentByGroup(prev => {
            const next = {...prev}
            if (!next[groupId]) next[groupId] = []
            if (next[groupId].some(s => s.shipmentId === shipment.id)) {
                next[groupId] = next[groupId].filter(s => s.shipmentId !== shipment.id)
                if (0 === next[groupId].length) {
                    delete next[groupId]
                }
            } else {
                next[groupId] = [...next[groupId], {shipmentId: shipment.id, shippingMethodId: shipment.shippingMethodId}]
            }
            return next
        })
    }

    function selectAllShipmentsInGroup(groupId, shipments) {
        setSelectedShipmentByGroup(prev => {
            const next = {...prev}
            const items = shipments.map(s => ({shipmentId: s.id, shippingMethodId: s.shippingMethodId}))
            next[groupId] = next[groupId]?.length === items.length ? [] : items
            if (0 === next[groupId].length) delete next[groupId]
            return next
        })
    }

    function getShipmentToBeMassTransferIdList() {
        return Object.keys(selectedShipmentByGroup).flatMap((groupId) => {
            return selectedShipmentByGroup[groupId]
        })
    }

    function groupByShippingMethod(shipments) {
        const grouped = {};
        shipments.forEach(shipment => {
            const key = shipment.shippingMethodId;
            if (!grouped[key]) {
                grouped[key] = {
                    id: shipment.shippingMethodId,
                    name: shipment.shippingMethod,
                    discr: shipment.shippingMethodDiscr,
                    icon: shipment.shippingMethodIcon,
                    shipments: [],
                };
            }
            grouped[key].shipments.push(shipment);
        });
        return Object.values(grouped);
    }

    function selectAllShipments() {
        groupByShippingMethod(container.shipments).forEach((group) => selectAllShipmentsInGroup(group.id, group.shipments))
    }

    function unSelectAll() {
        setSelectedShipmentByGroup({})
    }

    const handleCloseShipmentModal = () => {
        setOpenShipmentModal(false)
    }

    const handleManualSelection = () => {
        setOpenTipperManualSelectionDrawer(true)
    }

    const handleCloseManualSelectionDrawer = () => {
        setOpenTipperManualSelectionDrawer(false)
    }

    const handleSelectedTipper = (selectedContainerBarcode) => {
        getWMSContainerWithCodeBar(selectedContainerBarcode).then(r => {
            if (isCC && !isCcInternalWMSShip && r.type !== WmsContainerType.CC) {
                setCcError(true)
                setLoading(false)
                resetScannedString()
                setEnableScan(true)
                return
            }

            if (!isCC && r.type !== WmsContainerType.TIPPER && r.type !== WmsContainerType.TROLLEY) {
                setOpenWrongContainerScanToast(true)
                setLoading(false)
                resetScannedString()
                setEnableScan(true)
                return
            }

            if (isCC && isCcInternalWMSShip && r.type !== WmsContainerType.TIPPER && r.type !== WmsContainerType.TROLLEY) {
                setCcError(true)
                setLoading(false)
                resetScannedString()
                setEnableScan(true)
                return
            }

            if (currentOrganization.containerToShippingMethodMatch && !r.shippingMethods?.some((sm) => currentShipment.shippingMethodId === sm.id)) {
                setOpenWrongContainerScanToast(true)
                setLoading(false)
                resetScannedString()
                setEnableScan(true)
                return
            }


            assignShipmentToContainer(selectedContainerBarcode, currentShipment.id).then(() => {
                shipmentSorted(currentShipment.id).then(() => {})
            }).catch(err => {

            }).finally(() => {
                setOpenTipperManualSelectionDrawer(false)
                setOpenShipmentModal(false)
                setLoading(false)
                setEnableScan(true)
                resetScannedString()
                setResetList(!resetList)
            })
        })
    }

    const handleShipmentSelect = (selectedShipment) => {
        if (inSorting) {
            setCurrentShipment(selectedShipment)
            setOpenShipmentModal(true)
        }
    }

    const getToContainersForMassTransfer = () => {
        let toContainer = [ WmsContainerType.TIPPER, WmsContainerType.TROLLEY ]

        if (isCC && !isCcInternalWMSShip) {
            toContainer.push(WmsContainerType.CC)
        }

        return toContainer;
    }

    useEffect(() => {
        if (!massTransfer && scannedString && scannedString.length > 0) {
            setEnableScan(false)

            if (scannedString === container.codebar) {
                setInSorting(true)
                resetScannedString()
                setEnableScan()
                return
            }
            const scannedShipment = container.shipments.find((shipment) => shipment.shipmentBarcode === scannedString)

            if (scannedShipment) {
                setCurrentShipment(scannedShipment)
                setOpenShipmentModal(true)
                resetScannedString()
            } else {
                setEnableScan(true)
            }
        }
    }, [scannedString]);

    useEffect(() => {
        setEnableScan(true)
        if (currentShipment && (currentShipment.shippingMethodDiscr === ShippingMethodsDiscr.CLICK_COLLECT || (currentShipment.shippingMethodShopName === KNCarrierType.NAVETTE))) {
            setIsCC(true)
        } else {
            setIsCC(false)
        }
    }, [currentShipment]);

    useEffect(() => {
        if (currentInventory && currentShipment && currentShipment.ccPointCode) {
            setIsCcInternalWMSShip(currentInventory.code !== currentShipment.ccPointCode)
        }
    }, [currentInventory, currentShipment]);

    useEffect(() => {
        if (scannedShipment) {
            setCurrentShipment(scannedShipment)
        }
        resetScannedString()
    }, []);

    useEffect(() => {
        if (currentOrganization) {
            setMassTransfer(currentOrganization.triShippingMassTransfer)
        }
    }, [container, currentOrganization]);

    return (
        <RightDrawer
            open={open}
            handleClose={handleClose}
            headerLeftContent={<span style={{marginLeft: "8px"}}>{container.name}</span>}
            headerRightContent={<Badge rounded isBold={false}>{container.shipmentCount} <FormattedMessage id={"wms.triShipping.shipmentCount"}/></Badge>}
            footer={
                <Grid container flexWrap={"nowrap"}>
                    {!inSorting && (
                        <CustomButton onClick={() => beginSorting(container)} fullWidth>
                            <FormattedMessage id={"wms.triShipping.button.beginSorting"}/> {container.name}
                        </CustomButton>
                    )}

                    {massTransfer && inSorting && (
                        <Grid container flexWrap={"noWrap"} direction={isMobile ? "column" : "row"}>
                        <FullTransfer
                            handleIsValid={() => {
                                setResetList(prev => !prev)
                                unSelectAll()
                            }}
                            currentContainer={container}
                            inSorting={inSorting}
                            shipments={getShipmentToBeMassTransferIdList()}
                            onButtonClick={() => 0 === getShipmentToBeMassTransferIdList().length ? selectAllShipments() : {}}
                            customButtonLabel={
                                <FormattedMessage
                                    id={"wms.triSorting.FullTransfert.button.label"}
                                    values={{
                                        shipmentCount: 0 < getShipmentToBeMassTransferIdList().length ?
                                            getShipmentToBeMassTransferIdList()?.length :
                                            container.shipments.length
                                        }}
                                />
                        }
                            toContainers={getToContainersForMassTransfer()}
                        />

                            <CustomButton
                                color={'lightRed'}
                                onClick={() => unSelectAll()}
                                style={{marginLeft: '8px', marginTop: isMobile ? "8px" : 0}}
                                fullWidth={isMobile}
                            >
                                <FormattedMessage id={"wms.triSorting.unselect_all.button.label"}/>
                            </CustomButton>
                        </Grid>
                    )}
                </Grid>
            }
        >
            {openWrongContainerScanToast && (
                <Toast
                    open={openWrongContainerScanToast}
                    handleClose={() => {
                        setOpenWrongContainerScanToast(false)
                    }}
                    title={<FormattedMessage id={"wms.packing.toast.omniScan.wrongContainer.title"} />}
                    icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"validated-icon"}/>}
                    disablePortal={false}
                />
            )}

            {ccError && (
                <Toast
                    open={ccError}
                    handleClose={() => setCcError(false)}
                    title={<FormattedMessage id={"wms.triShipping.ccErrorToast.title"}/>}
                    subtitle={<FormattedMessage id={"wms.triShipping.ccErrorToast.subtitle"}/>}
                    icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"validated-icon"}/>}
                    disablePortal={false}
                />
            )}
            {openShipmentModal && currentShipment && (
                <ShipmentModal
                    open={openShipmentModal}
                    handleClose={handleCloseShipmentModal}
                    shipment={currentShipment}
                    sortShipment={handleSelectedTipper}
                    manualSelection={handleManualSelection}
                    loading={loading}
                    setLoading={setLoading}
                />
            )}

            {openTipperManualSelectionDrawer && currentShipment && (
                <TipperManualSelectionDrawer
                    open={openTipperManualSelectionDrawer}
                    handleClose={handleCloseManualSelectionDrawer}
                    handleSelectedTipper={handleSelectedTipper}
                    currentShipment={currentShipment}
                    isCC={isCC}
                    isCcInternalWMSShip={isCcInternalWMSShip}
                    loading={loading}
                    setLoading={setLoading}
                />
            )}

            <Grid container sx={{overflow: 'auto'}}>
                {container && groupByShippingMethod(container.shipments).map((group) => (
                    <Accordion key={group.id} sx={{width: "100%"}}>
                        <AccordionSummary expandIcon={<ArrowDownIcon/>}>
                            <Grid container alignItems={"center"} gap={"8px"} flexWrap={"nowrap"}>
                                {inSorting && massTransfer && (
                                    <ContainerCheckbox
                                        checked={groupHasSelectedShipments(group.id)}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            selectAllShipmentsInGroup(group.id, group.shipments)
                                        }}
                                    />
                                )}
                                <WMSCarrierIcon
                                    iconName={group.icon}
                                    altName={group.name}
                                    width={iconSize}
                                    height={iconSize}
                                />
                                <span>{group.name}</span>
                                {inSorting ? (
                                    <Badge rounded isBold={false}>
                                        {selectedShipmentByGroup?.[group.id]?.length || 0} / {group.shipments.length}
                                    </Badge>
                                ) : (
                                    <Badge rounded isBold={false}>{group.shipments.length} <FormattedMessage id={"wms.triShipping.shipmentCount"}/></Badge>
                                )}
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails sx={{padding: 0, backgroundColor: "white"}}>
                            {group.shipments.map((shipment) => (
                                inSorting ? (
                                    <AccordionShipmentItem
                                        key={shipment.id}
                                        noCheckbox={!massTransfer}
                                        checked={isShipmentSelected(shipment.id, group.id)}
                                        onCheckBoxClick={(e) => {
                                            e.stopPropagation()
                                            selectShipment(shipment, group.id)
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            handleShipmentSelect(shipment)
                                        }}
                                        trackingNumber={shipment.trackingNumber}
                                        orderId={currentOrganization?.showDisplayExternalId && shipment.orderNumber ? shipment.orderNumber : shipment.orderExternalId}
                                    />
                                ) : (
                                    <div key={shipment.id} style={{width: "100%"}} onClick={() => handleShipmentSelect(shipment)}>
                                        <MobileItem>
                                            <MobileItem.LeftSide
                                                title={
                                                    <>
                                                        <FormattedMessage id={"wms.triShipping.orderNumberLabel"}/>
                                                        <span style={{color: blueColor}}>
                                                            {/*Here, orderNumber is orderDisplayExternalId*/}
                                                            #{currentOrganization?.showDisplayExternalId && shipment.orderNumber ? shipment.orderNumber : shipment.orderExternalId}
                                                        </span>
                                                    </>
                                                }
                                                subtitle={
                                                    <>
                                                        <FormattedMessage id={"wms.triShipping.trackingNumber"}/>
                                                        <span style={{color: blueColor}}>
                                                            #{shipment.trackingNumber}
                                                        </span>
                                                    </>
                                                }
                                            />
                                        </MobileItem>
                                    </div>
                                )
                            ))}
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Grid>
        </RightDrawer>
    );
}

export default ContainerDrawer;
